import { render } from "./Attributes.vue?vue&type=template&id=39e60f8a&scoped=true"
import script from "./Attributes.vue?vue&type=script&lang=js"
export * from "./Attributes.vue?vue&type=script&lang=js"

import "./Attributes.vue?vue&type=style&index=0&id=39e60f8a&scoped=true&lang=css"

import exportComponent from "../../../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39e60f8a"]])

export default __exports__